import { internalApi } from '@/lib/axiosConfig/internalApi';
import axios from 'axios';
import { OffersResponse } from '@/types/offerWall';
import { SubmissionRequest } from '@/types/pipedream';
import { isServer } from '@/utils/isServer';
import { InternalPipedreamService } from '../InternalServices/InternalPipedreamService';

export class PipedreamService {
  static async createSubmission(data: SubmissionRequest) {
    const isServerSide = isServer();
    if (isServerSide) {
      const response = await InternalPipedreamService.createSubmission(data);
      return response;
    }
    const response = await internalApi.post<OffersResponse>(
      '/api/pipedream/create-submission',
      data
    );
    return response;
  }

  static async secondRunSubmission(data: SubmissionRequest) {
    const isServerSide = isServer();
    if (isServerSide) {
      const response = await InternalPipedreamService.secondRunSubmission(data);
      return response;
    }
    const response = await internalApi.post<OffersResponse>(
      '/api/pipedream/second-run-submission',
      data
    );
    return response;
  }

  static async agentReviewOffers(data: SubmissionRequest) {
    const isServerSide = isServer();
    if (isServerSide) {
      const response = await InternalPipedreamService.agentReviewOffers(data);
      return response;
    }
    const response = await internalApi.post<OffersResponse>(
      '/api/pipedream/agent-review-offers',
      data
    );
    return response;
  }

  static async getUserIpAddress() {
    try {
      const response = await axios.get<{ ip: string }>(
        'https://api.ipify.org/?format=json'
      );

      return response;
    } catch (e) {
      console.log(e);

      return {
        data: {
          ip: '',
        },
      };
    }
  }

  static async triPointSubmission(data: SubmissionRequest) {
    const isServerSide = isServer();
    if (isServerSide) {
      const response = await InternalPipedreamService.triPointSubmission(data);
      return response;
    }
    const response = await internalApi.post<{ recordId: string }>(
      '/api/pipedream/tri-point-submission',
      data
    );
    return response;
  }

  static async selfServiceSubmission(data: SubmissionRequest) {
    const isServerSide = isServer();
    if (isServerSide) {
      const response =
        await InternalPipedreamService.selfServiceSubmission(data);
      return response;
    }
    const response = await internalApi.post<OffersResponse>(
      '/api/pipedream/self-service-submission',
      data
    );
    return response;
  }

  static async calculatorSubmission(data: SubmissionRequest) {
    const isServerSide = isServer();
    if (isServerSide) {
      const response =
        await InternalPipedreamService.calculatorSubmission(data);
      return response;
    }
    const response = await internalApi.post<OffersResponse>(
      '/api/pipedream/calculator-submission',
      data
    );
    return response;
  }

  static async referralSubmission(data: SubmissionRequest) {
    const isServerSide = isServer();
    if (isServerSide) {
      const response = await InternalPipedreamService.referralSubmission(data);
      return response;
    }
    const response = await internalApi.post<OffersResponse>(
      '/api/pipedream/referral-submission',
      data
    );
    return response;
  }

  static async logEmptyOffersWarning(submissionId: string) {
    if (isServer()) {
      await InternalPipedreamService.logEmptyOffersWarning(submissionId);
      return;
    }
    await internalApi.post('/api/log/empty-offers', { submissionId });
  }
}
